module.exports = __webpack_public_path__ + "img/Reset-Aria_back.0a8e09d1.png";